// @flow
import update from 'immutability-helper';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import {
  postForecastClassicPriceApi,
  postForecastClassicPriceCartApi,
  postForecastClassicPriceBagApi,
  postForecastDiyPriceApi,
  postForecastDiyPriceCartApi,
  postForecastDiyPriceBagApi,
  getRelatedProductsApi,
  postMissingSumCartApi,
  postMissingSumItemsApi,
  endpoints as quoteEndpoints,
} from './api';

import type { HTTPError } from '../../../error';
import type { Forecast, ForecastCourier, ForecastPricesApiReq, ForecastTier } from './api';
import type { MissingSumApiReq } from './api';

type QuoteStepAction = {
  +type: string;
  +error?: HTTPError;
  +forecast?: Forecast;
  +forecastRequest?: ForecastPricesApiReq;
  +selectedIndex?: number;
  +couponCode?: string;
  +missingSum?: { [key: string]: string };
  +missingSumRequest?: MissingSumApiReq;
  +categoriesIds?: { [key: string]: string };
  +relatedProducts?: any;
};

export type QuoteStepState = {
  // +isApplyingCoupon?: boolean;
  // +applyCouponError?: HTTPError;
  // +isRemovingCoupon?: boolean;
  // +removeCouponError?: HTTPError;
  +isLoadingForecast?: boolean;
  +forecastError?: HTTPError;
  +forecast?: Forecast;
  // +previousForecast?: Forecast;
  // Selected index from forecast array
  // +selectedIndex?: number;
  +appliedCoupon?: string;
  +missingSum?: { [key: string]: string };
  +isPostingMissingSum?: boolean;
  +postMissingSumError?: HTTPError;
  +isFetchingProducts?: boolean;
  // +relatedProducts?: any;
  +fetchProductsError?: HTTPError;
};

const RELATED_PRODUCTS_MAX_QUANTITY = 4;

// Actions
const QUOTE_STEP_APPLY_COUPON_REQUEST = 'QUOTE_STEP_APPLY_COUPON_REQUEST';
// const QUOTE_STEP_APPLY_COUPON_SUCCESS = 'QUOTE_STEP_APPLY_COUPON_SUCCESS';
// const QUOTE_STEP_APPLY_COUPON_ERROR = 'QUOTE_STEP_APPLY_COUPON_ERROR';

const QUOTE_STEP_REMOVE_COUPON_REQUEST = 'QUOTE_STEP_REMOVE_COUPON_REQUEST';
// const QUOTE_STEP_REMOVE_COUPON_SUCCESS = 'QUOTE_STEP_REMOVE_COUPON_SUCCESS';
// const QUOTE_STEP_REMOVE_COUPON_ERROR = 'QUOTE_STEP_REMOVE_COUPON_ERROR';

const QUOTE_STEP_FORECAST_PRICES_REQUEST = 'QUOTE_STEP_FORECAST_PRICES_REQUEST';
const QUOTE_STEP_FORECAST_PRICES_SUCCESS = 'QUOTE_STEP_FORECAST_PRICES_SUCCESS';
const QUOTE_STEP_FORECAST_PRICES_ERROR = 'QUOTE_STEP_FORECAST_PRICES_ERROR';

// const QUOTE_STEP_SET_SELECTED_INDEX = 'QUOTE_STEP_SET_SELECTED_INDEX';

const QUOTE_STEP_REDIRECT_TO_BAG = 'QUOTE_STEP_REDIRECT_TO_BAG';

const QUOTE_STEP_MISSING_SUM_CART_REQUEST = 'QUOTE_STEP_MISSING_SUM_CART_REQUEST';
const QUOTE_STEP_MISSING_SUM_ITEMS_REQUEST = 'QUOTE_STEP_MISSING_SUM_ITEMS_REQUEST';
const QUOTE_STEP_MISSING_SUM_SUCCESS = 'QUOTE_STEP_MISSING_SUM_SUCCESS';
const QUOTE_STEP_MISSING_SUM_ERROR = 'QUOTE_STEP_MISSING_SUM_ERROR';

const QUOTE_STEP_FETCH_RELATED_PRODUCTS_REQUEST = 'QUOTE_STEP_FETCH_RELATED_PRODUCTS_REQUEST';
const QUOTE_STEP_FETCH_RELATED_PRODUCTS_SUCCESS = 'QUOTE_STEP_FETCH_RELATED_PRODUCTS_SUCCESS';
const QUOTE_STEP_FETCH_RELATED_PRODUCTS_ERROR = 'QUOTE_STEP_FETCH_RELATED_PRODUCTS_ERROR';

const QUOTE_STEP_RESET_STATE = 'QUOTE_STEP_RESET_STATE';

// Actions creators

export function applyCoupon(couponCode: string): QuoteStepAction {
  return {
    type: QUOTE_STEP_APPLY_COUPON_REQUEST,
    couponCode,
  };
}

/* export function applyCouponSuccess(payment: Payment): QuoteStepAction {
  return {
    type: QUOTE_STEP_APPLY_COUPON_SUCCESS,
    payment,
  };
}

export function applyCouponErrorFn(error: HTTPError): QuoteStepAction {
  return {
    type: QUOTE_STEP_APPLY_COUPON_ERROR,
    error,
  };
}
*/
export function removeCoupon(couponCode: string): QuoteStepAction {
  return {
    type: QUOTE_STEP_REMOVE_COUPON_REQUEST,
    couponCode,
  };
}

/* export function removeCouponSuccess(payment: Payment): QuoteStepAction {
  return {
    type: QUOTE_STEP_REMOVE_COUPON_SUCCESS,
    payment,
  };
}

export function removeCouponErrorFn(error: HTTPError): QuoteStepAction {
  return {
    type: QUOTE_STEP_REMOVE_COUPON_ERROR,
    error,
  };
}*/

export function forecastPrices(forecastRequest: ForecastPricesApiReq): QuoteStepAction {
  return {
    type: QUOTE_STEP_FORECAST_PRICES_REQUEST,
    forecastRequest,
  };
}

export function forecastPricesSuccess(forecast: Forecast): QuoteStepAction {
  return {
    type: QUOTE_STEP_FORECAST_PRICES_SUCCESS,
    forecast,
  };
}

export function forecastPricesErrorFn(error: HTTPError): QuoteStepAction {
  return {
    type: QUOTE_STEP_FORECAST_PRICES_ERROR,
    error,
  };
}


/*export function setSelectedIndex(selectedIndex: number): QuoteStepAction {
  return {
    type: QUOTE_STEP_SET_SELECTED_INDEX,
    selectedIndex,
  };
}*/

export function redirectToBag(bagId: string): QuoteStepAction {
  return {
    type: QUOTE_STEP_REDIRECT_TO_BAG,
    bagId,
  }
}

export function postMissingSumCart(): QuoteStepAction {
  return {
    type: QUOTE_STEP_MISSING_SUM_CART_REQUEST,
  };
}

export function postMissingSumItems(missingSumRequest: MissingSumApiReq): QuoteStepAction {
  return {
    type: QUOTE_STEP_MISSING_SUM_ITEMS_REQUEST,
    missingSumRequest,
  };
}

export function postMissingSumSuccess(missingSum: { [key: string]: string }): QuoteStepAction {
  return {
    type: QUOTE_STEP_MISSING_SUM_SUCCESS,
    missingSum,
  };
}

export function postMissingSumErrorFn(error: HTTPError): QuoteStepAction {
  return {
    type: QUOTE_STEP_MISSING_SUM_ERROR,
    error,
  };
}

export function fetchRelatedProducts(categoriesIds: { [key: string]: string }): QuoteStepAction {
  return {
    type: QUOTE_STEP_FETCH_RELATED_PRODUCTS_REQUEST,
    categoriesIds,
  };
}

export function fetchRelatedProductsSuccess(relatedProducts: any): QuoteStepAction {
  return {
    type: QUOTE_STEP_FETCH_RELATED_PRODUCTS_SUCCESS,
    relatedProducts,
  };
}

export function fetchRelatedProductsErrorFn(error: HTTPError): QuoteStepAction {
  return {
    type: QUOTE_STEP_FETCH_RELATED_PRODUCTS_ERROR,
    error,
  };
}

export function resetState(): QuoteStepAction {
  return {
    type: QUOTE_STEP_RESET_STATE,
  };
}

export const actions = {
  QUOTE_STEP_APPLY_COUPON_REQUEST,
  /* QUOTE_STEP_APPLY_COUPON_SUCCESS,
  QUOTE_STEP_APPLY_COUPON_ERROR,*/
  QUOTE_STEP_REMOVE_COUPON_REQUEST,
  /* QUOTE_STEP_REMOVE_COUPON_SUCCESS,
  QUOTE_STEP_REMOVE_COUPON_ERROR,*/
  QUOTE_STEP_FORECAST_PRICES_REQUEST,
  QUOTE_STEP_FORECAST_PRICES_SUCCESS,
  QUOTE_STEP_FORECAST_PRICES_ERROR,
  // QUOTE_STEP_SET_SELECTED_INDEX,
  QUOTE_STEP_REDIRECT_TO_BAG,
  QUOTE_STEP_MISSING_SUM_CART_REQUEST,
  QUOTE_STEP_MISSING_SUM_ITEMS_REQUEST,
  QUOTE_STEP_MISSING_SUM_SUCCESS,
  QUOTE_STEP_MISSING_SUM_ERROR,
  QUOTE_STEP_FETCH_RELATED_PRODUCTS_REQUEST,
  QUOTE_STEP_FETCH_RELATED_PRODUCTS_SUCCESS,
  QUOTE_STEP_FETCH_RELATED_PRODUCTS_ERROR,
  QUOTE_STEP_RESET_STATE,
  applyCoupon,
  /* applyCouponSuccess,
  applyCouponErrorFn,*/
  removeCoupon,
  /* removeCouponSuccess,
  removeCouponErrorFn,*/
  forecastPrices,
  forecastPricesSuccess,
  forecastPricesErrorFn,
  // setSelectedIndex,
  redirectToBag,
  postMissingSumCart,
  postMissingSumItems,
  postMissingSumSuccess,
  postMissingSumErrorFn,
  fetchRelatedProducts,
  fetchRelatedProductsSuccess,
  fetchRelatedProductsErrorFn,
  resetState,
};

export const initialState: QuoteStepState = {};

// Reducer
export default function reducer(state: QuoteStepState = initialState, action: QuoteStepAction): QuoteStepState {
  switch (action.type) {
    case QUOTE_STEP_APPLY_COUPON_REQUEST:
      return update(state, {
        appliedCoupon: { $set: action.couponCode },
      });
    /*case QUOTE_STEP_APPLY_COUPON_ERROR:
      return update(state, {
        $unset: ['isApplyingCoupon'],
        applyCouponError: { $set: action.error },
      });*/
    case QUOTE_STEP_REMOVE_COUPON_REQUEST:
      return update(state, {
        $unset: ['appliedCoupon'],
      });
    /*case QUOTE_STEP_REMOVE_COUPON_ERROR:
      return update(state, {
        $unset: ['isRemovingCoupon'],
        removeCouponError: { $set: action.error },
      });*/
    case QUOTE_STEP_FORECAST_PRICES_REQUEST:
      return update(state, {
        isLoadingForecast: { $set: true },
        $unset: ['forecastError'],
        // $unset: ['forecast'],
        // $unset: ['selectedIndex'],
      });
    case QUOTE_STEP_FORECAST_PRICES_SUCCESS:
      return update(state, {
        forecast: { $set: action.forecast },
        // selectedIndex: { $set: Math.max((action.forecast || []).length - 1, 0) },
        $unset: ['isLoadingForecast'],
      });
    case QUOTE_STEP_FORECAST_PRICES_ERROR:
      return update(state, {
        $unset: ['isLoadingForecast'],
        // selectedIndex: { $set: Math.max((state.forecast || []).length - 1, 0) },
        forecastError: { $set: action.error },
      });
    /*case QUOTE_STEP_SET_SELECTED_INDEX:
      return update(state, {
        selectedIndex: { $set: action.selectedIndex },
      });*/
    case QUOTE_STEP_MISSING_SUM_CART_REQUEST:
    case QUOTE_STEP_MISSING_SUM_ITEMS_REQUEST:
      return update(state, {
        isPostingMissingSum: { $set: true },
      });
    case QUOTE_STEP_MISSING_SUM_SUCCESS:
      return update(state, {
        $unset: ['isPostingMissingSum'],
        missingSum: { $set: action.missingSum },
      });
    case QUOTE_STEP_MISSING_SUM_ERROR:
      return update(state, {
        $unset: ['isPostingMissingSum'],
        postMissingSumError: { $set: action.error },
      });
    case QUOTE_STEP_FETCH_RELATED_PRODUCTS_REQUEST:
      return update(state, {
        isFetchingProducts: { $set: true },
        $unset: ['fetchProductsError'],
      });
    case QUOTE_STEP_FETCH_RELATED_PRODUCTS_SUCCESS:
      if (!action.relatedProducts) return state;
      return update(state, {
        relatedProducts: { $set: action.relatedProducts.slice(0, RELATED_PRODUCTS_MAX_QUANTITY) },
        $unset: ['isFetchingProducts'],
      });
    case QUOTE_STEP_FETCH_RELATED_PRODUCTS_ERROR:
      return update(state, {
        fetchProductsError: { $set: action.error },
        $unset: ['isFetchingProducts'],
      });
    case QUOTE_STEP_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// Epics
/*export function newOrderApplyCouponEpic(action$: Observable<QuoteStepAction>) {
  return action$.pipe(
    ofType(QUOTE_STEP_APPLY_COUPON_REQUEST),
    mergeMap(({ id, couponCode }) => postApplyCouponApi({ orderId: id, couponCode }).pipe(
      mergeMap((payment: Payment) => {
        if (parseInt(payment.total, 10) === 0) {
          return of(applyCouponSuccess(payment), checkoutGenericExecuteSuccess(id));
        }
        return of(applyCouponSuccess(payment));
      }),
      catchError((e: HTTPError) => of(applyCouponErrorFn(e))),
    )),
  );
}

export function newOrderRemoveCouponEpic(action$: Observable<QuoteStepAction>) {
  return action$.pipe(
    ofType(QUOTE_STEP_REMOVE_COUPON_REQUEST),
    mergeMap(({ id }) => postRemoveCouponApi({ orderId: id }).pipe(
      map((payment: Payment) => removeCouponSuccess(payment)),
      catchError((e: HTTPError) => of(removeCouponErrorFn(e))),
    )),
  );
}*/

export function newOrderQuoteForecastPricesEpic(action$: Observable<QuoteStepAction>): Observable<QuoteStepAction> {
  return action$.pipe(
    ofType(QUOTE_STEP_FORECAST_PRICES_REQUEST/*, QUOTE_STEP_EDIT_ITEM_SUCCESS, QUOTE_STEP_DELETE_ITEM_SUCCESS,
      ShoppingCartActions.SHOPPING_CART_EDIT_ITEM_SUCCESS, ShoppingCartActions.SHOPPING_CART_DELETE_ITEM_SUCCESS*/),
    mergeMap(({ forecastRequest }: { forecastRequest: ForecastPricesApiReq }) => {
      const req = {
        ...forecastRequest,
      };
      const { bagId, items } = forecastRequest;
      delete req.bagId;
      let obs: Observable[] = [];
      // Detect if bag, with items or cart
      if (!!bagId) {
        obs = [
          postForecastDiyPriceBagApi(req, {
            route: quoteEndpoints.FORECAST_PRICE_BAG_DIY.replace(':bagId', bagId),
          }),
          postForecastClassicPriceBagApi(req, {
            route: quoteEndpoints.FORECAST_PRICE_BAG_CLASSIC.replace(':bagId', bagId),
          }),
        ];
      } else if (!!items) {
        obs = [postForecastDiyPriceApi(req), postForecastClassicPriceApi(req)];
      } else {
        obs = [postForecastDiyPriceCartApi(req), postForecastClassicPriceCartApi(req)];
      }

      return forkJoin(obs).pipe(
        mergeMap(([diy, classic]: [ForecastCourier[], ForecastTier[]]) => {
          const forecast = {
            DIY: diy,
            CLASSIC: classic,
          };
          // If coupon was applied
          if (forecastRequest.couponCode && ((classic.length > 0 && classic[0].couponDiscount) ||
            (diy.length > 0 && diy[0].couponDiscount))) {
            const couponAction = applyCoupon(forecastRequest.couponCode);
            return of(forecastPricesSuccess(forecast), couponAction);
          }
          return of(forecastPricesSuccess(forecast));
        }),
        catchError((e: HTTPError) => of(forecastPricesErrorFn(e))),
      );
    }),
    /*mergeMap(({ forecastRequest }) => {
      const req = {
        ...forecastRequest,
      };
      const { bagId, items } = forecastRequest;
      delete req.bagId;
      let obs;
      if (!!bagId) {
        obs = postForecastPriceBagApi(req, {
          route: quoteEndpoints.FORECAST_PRICE_BAG.replace(':bagId', bagId),
        });
      } else if (items) {
        obs = postForecastPriceApi(req);
      } else {
        obs = postForecastPriceCartApi(req);
      }
      return obs.pipe(
        mergeMap((forecast: Forecast) => {
          if (forecast.length > 0 && forecast[0].couponDiscount) {
            return of(forecastPricesSuccess(forecast), applyCoupon(forecastRequest.couponCode));
          }
          return of(forecastPricesSuccess(forecast));
        }),
        catchError((e: HTTPError) => of(forecastPricesErrorFn(e))),
      )
    }),*/
  );
}

/*export function newOrderQuoteReForecastBagEpic(action$: Observable<QuoteStepAction>) {
  return action$.pipe(
    ofType(QUOTE_STEP_EDIT_ITEM_SUCCESS, QUOTE_STEP_DELETE_ITEM_SUCCESS),
    map(({ bag }) => forecastPrices({
      purchaseCountry: 'US',
      deliveryCountry: 'PE',
      items: [...bag.items.map((item: BagItem) => {
        return {
          amount: item.amount,
          originalPackaging: item.originalPackaging,
          price: item.price,
          url: item.url,
          weight: item.weight,
        }
      })],
    })),
  );
}

export function newOrderQuoteReForecastCartEpic(action$: Observable<QuoteStepAction>) {
  return action$.pipe(
    ofType(ShoppingCartActions.SHOPPING_CART_EDIT_ITEM_SUCCESS, ShoppingCartActions.SHOPPING_CART_DELETE_ITEM_SUCCESS),
    map(() => forecastPrices({
      purchaseCountry: 'US',
      deliveryCountry: 'PE',
    })),
  );
}*/

export function newOrderQuotePostMissingCartEpic(action$: Observable<QuoteStepAction>): Observable<QuoteStepAction> {
  return action$.pipe(
    ofType(QUOTE_STEP_MISSING_SUM_CART_REQUEST),
    mergeMap(_ =>
      postMissingSumCartApi().pipe(
        map((missingSum: { [key: string]: string }) => postMissingSumSuccess(missingSum)),
        catchError((e: HTTPError) => {
          if (Math.round(e.code / 100) === 5) {
            return of(postMissingSumErrorFn(e));
          } else if (e.code === 400) {
            return of(postMissingSumErrorFn(e))
          }
          return of(postMissingSumErrorFn(e))
        }),
      ),
    ),
  );
}


export function newOrderQuotePostMissingSumItemsEpic(action$: Observable<QuoteStepAction>): Observable<QuoteStepAction> {
  return action$.pipe(
    ofType(QUOTE_STEP_MISSING_SUM_ITEMS_REQUEST),
    mergeMap(({ missingSumRequest }) =>
      postMissingSumItemsApi(missingSumRequest).pipe(
        map((missingSum: { [key: string]: string }) => postMissingSumSuccess(missingSum)),
        catchError((e: HTTPError) => {
          if (Math.round(e.code / 100) === 5) {
            return of(postMissingSumErrorFn(e));
          } else if (e.code === 400) {
            return of(postMissingSumErrorFn(e))
          }
          return of(postMissingSumErrorFn(e))
        }),
      ),
    ),
  );
}

export function newOrderQuoteFetchRelatedProductsEpic(action$: Observable<QuoteStepAction>): Observable<QuoteStepAction> {
  return action$.pipe(
    ofType(QUOTE_STEP_FETCH_RELATED_PRODUCTS_REQUEST),
    mergeMap(({ categoriesIds }) => getRelatedProductsApi({ ...categoriesIds }).pipe(
      map((relatedProducts: any) => fetchRelatedProductsSuccess(relatedProducts)),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(fetchRelatedProductsErrorFn(e));
        } else if (e.code === 400) {
          return of(fetchRelatedProductsErrorFn(e));
        }
        return of(fetchRelatedProductsErrorFn(e));
      }),
    )),
  );
}



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/duck.js